<div [hidden]="g.hide('mnexamview')==true" class="card-header">
    <h4 class="card-title">{{'admin.exam' | translate}} </h4>
  </div>

  <div class="row">
    <div class=" col-lg-4 col-md-6 col-sm-12">
        <mat-form-field appearance="fill">
            <mat-label>{{'general.examcodename' | translate}}</mat-label>
            <input [(ngModel)]="examCode" matInput>
          </mat-form-field>
      </div>
    
    <div class=" col-lg-4 col-md-3 col-sm-12">
      <mat-form-field appearance="fill">
        <mat-label>{{'general.Coursetitle' | translate}}</mat-label>
        <mat-select [formControl]="courseCtrl">
          <mat-option *ngFor="let course of courses" [value]="course.code">{{course.arabicTitle}}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  
    
     <!--  <div class=" col-lg-2 col-md-6 col-sm-12">
        <mat-form-field appearance="fill">
            <mat-label>{{'general.examstartdate' | translate}}</mat-label>
            <input matInput>
          </mat-form-field>
      </div> -->
     <!--  <div class=" col-lg-2 col-md-6 col-sm-12">
        <mat-form-field appearance="fill">
            <mat-label>{{'general.examenddate' | translate}}</mat-label>
            <input matInput>
          </mat-form-field>
      </div>
      <div class=" col-lg-2 col-md-6 col-sm-12">
        <mat-form-field appearance="fill">
            <mat-label>{{'general.creatby' | translate}}</mat-label>
            <input matInput>
          </mat-form-field>
      </div>
    
 -->
    <div class=" col-lg-1 col-md-6 col-sm-12">
  
    <button  (click)="getExams()" mat-raised-button color="primary"><i class="fas fa-search"></i></button>
  </div>
  </div>

  <hr>

  <div class="table-responsive">

    <div [hidden]="g.hide('mnexamform')==true" class="d-flex justify-content-center align-items-center">
        <button  mat-raised-button class="table-action" [routerLink]="['/auth/basic-data/exam-form']" color="primary">
             <i class="fas fa-plus"></i> {{'admin.addexam' | translate}}</button>
      </div>

    <table class="table table-striped table-bordered" >
      <thead>
        <tr>
          <th>{{'general.examcode' | translate}}</th>
          <th>{{'general.examname' | translate}} </th>
          <th>{{'general.examstartdate' | translate}} </th>
          <th>{{'general.examenddate' | translate}} </th>
          <th>{{'general.Coursetitle' | translate}} </th>
          <th>{{'general.publishstatus' | translate}} </th>
          <th>{{'general.proc' | translate}} </th>

        </tr>
      </thead>
      <tbody>
  
        <tr *ngFor="let ex of exams;let i=index">
          <td>	{{ex.examCode}}</td>
          <td>{{ex.examName}}</td>
          <td> {{ex.startFrom | date:'dd/MM/yyyy HH:mm'}}	</td>
          <td>{{ex.endAt | date:'dd/MM/yyyy HH:mm'}}</td>
          <td>{{ex.course.arabicTitle}}</td>
          <td>
             <img  src="assets/images/check.png" style="width: 25px; height: 25px;" alt="seu"></td>
          <td>
           <!--  <button mat-raised-button class=" table-action3" (click)="openDialogexam()" color="primary" style=" background-color: #3f51b5!important;"> 
              <i class="far fa-eye"></i>
          </button> -->
            <button mat-raised-button class=" table-action3" color="primary" [routerLink]="['/auth/basic-data/exam-form',ex.id]"> 
                <i class="far fa-edit"></i>
            </button>
            <button (click)="deleteExam(ex.id,i)" mat-raised-button class=" table-action3" color="warn" data-toggle="modal"
            data-target="#remove-exam"> 
                <i class="fas fa-times"></i>
            </button>
          </td>

        </tr>
      </tbody>
  
    </table>
    <mat-paginator  style="direction:ltr;"
          [length]="length"
          [pageIndex]="page"
          [pageSize]="pageSize"
          (page)="onPageChange($event)"
          >
        </mat-paginator>
  
  </div>

  <div class="modal fade" id="remove-exam" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered " role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLongTitle"> {{'basicdata.removeconfirm' | translate}}</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="state" style="text-align: center;">
            <img src="assets/images/remove.png" width="80px">
            <h2 class="success" style="color: #283045;margin-top: 10px;"> {{'basicdata.removeconfirm' | translate}}</h2>
          </div>
        </div>
        <div class="modal-footer">
          <div class="row">
            <div class="col-6">
              <button (click)="confirmDelete()" type="button" class="btn-add btn-block" data-dismiss="modal">
                {{'basicdata.doctor.remove' | translate}}</button>
            </div>
            <div class="col-6">
              <button (click)="cancel()" type="button" class="btn-add btn-block"
                data-dismiss="modal">{{'basicdata.cancel' | translate}}</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
